import Button from 'components/Common/Button';
import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import classNames from 'classnames';

import OPCLogoIMG from 'assets/img/logo-opc.png';
import SentinelLogoIMG from 'assets/img/logo-sentinel.png';
import getTranslate from '../../customHooks/getTranslate';

import { ProductCard } from '.';

import styles from './styles.module.scss';

const ProductList: React.FC = () => (
  <section className="d-flex">
    <ProductCard className="ms-4">
      <div className={classNames('mx-auto mb-4', styles.logo)}>
        <img src={OPCLogoIMG} alt="OPC Billing" className="img-fluid" />
      </div>
      <Button variant="primary" className="mx-auto" href={`${window.location.origin}/billing`}>
        <MdArrowForward />
        {getTranslate('access')}
      </Button>
    </ProductCard>
    <ProductCard className="ms-4">
      <div className={classNames('mx-auto mb-4', styles.logo)}>
        <img src={SentinelLogoIMG} alt="OPC Sentinel" className="img-fluid" />
      </div>
      <Button variant="primary" className="mx-auto" href={`${window.location.origin}/sentinel`}>
        <MdArrowForward />
        {getTranslate('access')}
      </Button>
    </ProductCard>
  </section>
);

export default ProductList;
